import logoFullText from 'src/assets/images/logos/logo_full_text.svg';
import logoRalph from 'src/assets/images/logos/ralph.svg';
import logoOahuFull from 'src/assets/images/logos/oahucity-full.png';
import logoLumisight from 'src/assets/images/logos/lumisight.png';
import background from 'src/assets/images/background_login.svg';
import iconFolderEmpty from 'src/assets/images/icons/ic_folder_empty.png';
import iconFileJpg from 'src/assets/images/icons/ic_jpg.png';
import iconFilePng from 'src/assets/images/icons/ic_png.png';
import iconFilePdf from 'src/assets/images/icons/ic_pdf.png';
import iconFileDoc from 'src/assets/images/icons/ic_doc.png';
import iconFilePpt from 'src/assets/images/icons/ic_ppt.png';
import iconFileXls from 'src/assets/images/icons/ic_xls.png';
import iconFileTxt from 'src/assets/images/icons/ic_txt.png';
import iconFileOdt from 'src/assets/images/icons/ic_odt.png';
import iconFileMp3 from 'src/assets/images/icons/ic_mp3.png';
import iconFileM4a from 'src/assets/images/icons/ic_m4a.png';
import iconFileWav from 'src/assets/images/icons/ic_wav.png';
import iconFileMp4 from 'src/assets/images/icons/ic_mp4.png';
import iconFileMpg from 'src/assets/images/icons/ic_mpg.png';
import iconFileM4v from 'src/assets/images/icons/ic_m4v.png';
import iconFileWmv from 'src/assets/images/icons/ic_wmv.png';
import iconFileMov from 'src/assets/images/icons/ic_mov.png';
import iconFileAvi from 'src/assets/images/icons/ic_avi.png';
import iconFileSwf from 'src/assets/images/icons/ic_swf.png';
import iconFileZip from 'src/assets/images/icons/ic_zip.png';
import iconFileRar from 'src/assets/images/icons/ic_raw.png';
import iconFile7zi from 'src/assets/images/icons/ic_7zi.png';
import iconFileRaw from 'src/assets/images/icons/ic_file_raw.png';
import iconFilePtx from 'src/assets/images/icons/ic_ptx.png';
import iconDepositionRejected from 'src/assets/images/icons/ic_rejected.png';

export const IMAGES = {
  logoFullText,
  logoRalph,
  logoOahuFull,
  logoLumisight,
  background,
  iconFolderEmpty,
  iconFileJpg,
  iconFilePng,
  iconFilePdf,
  iconFileDoc,
  iconFilePpt,
  iconFileXls,
  iconFileTxt,
  iconFileOdt,
  iconFileMp3,
  iconFileM4a,
  iconFileWav,
  iconFileMp4,
  iconFileM4v,
  iconFileMpg,
  iconFileWmv,
  iconFileMov,
  iconFileAvi,
  iconFileSwf,
  iconFileZip,
  iconFileRar,
  iconFile7zi,
  iconFileRaw,
  iconFilePtx,
  iconDepositionRejected,
};
